export default __webpack_public_path__ + "static/media/rotimatic.6a53fc84.png";